module.exports = __webpack_public_path__ + "img/24.deb697d1.jpg";